import { useNavigate } from "react-router-dom";
import { Bookmark, X } from "lucide-react";
import { toast } from "sonner";
import { setBookmark, errorDetail } from "@/lib/reader";

export default function ReaderBookmarks({ books, bookmarks, onChanged }) {
  const navigate = useNavigate();
  const groups = books
    .map((b) => ({ book: b, marks: [...(bookmarks?.[b.id] || [])].sort((x, y) => x.page - y.page) }))
    .filter((g) => g.marks.length);

  const remove = async (bookId, page) => {
    try {
      await setBookmark(bookId, page, false);
      onChanged();
    } catch (e) {
      toast.error(errorDetail(e));
    }
  };

  return (
    <section className="mt-20" data-testid="reader-bookmarks">
      <h2 className="font-serif-display text-3xl flex items-center gap-3">
        <Bookmark className="w-6 h-6 text-primary-gold" /> Your Bookmarks
      </h2>
      {groups.length === 0 ? (
        <p className="text-soft text-sm mt-4" data-testid="reader-bookmarks-empty">
          Tap the bookmark icon while reading to save a favourite page here.
        </p>
      ) : (
        <div className="mt-8 grid md:grid-cols-2 gap-8">
          {groups.map(({ book, marks }) => (
            <div key={book.id} data-testid={`bookmarks-group-${book.product_id}`}>
              <p className="font-mono-ui text-xs uppercase tracking-[0.2em] text-primary-gold mb-3">{book.title}</p>
              <ul className="space-y-2">
                {marks.map((m) => (
                  <li key={m.page} className="group flex items-stretch border border-white/10 bg-[#121212]/80 hover:border-primary-gold/40 transition-colors">
                    <button
                      onClick={() => navigate(`/reader/read/${book.id}?page=${m.page}`)}
                      data-testid={`bookmark-jump-${book.product_id}-${m.page}`}
                      className="flex-1 text-left px-4 py-3 min-w-0"
                    >
                      <span className="font-mono-ui text-xs text-primary-gold mr-3">p. {m.page}</span>
                      <span className="text-sm text-soft group-hover:text-text-primary transition-colors">{m.label}</span>
                    </button>
                    <button
                      onClick={() => remove(book.id, m.page)}
                      data-testid={`bookmark-remove-${book.product_id}-${m.page}`}
                      className="px-3 text-soft hover:text-[#d6453a] transition-colors"
                      aria-label="Remove bookmark"
                    >
                      <X className="w-4 h-4" />
                    </button>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>
      )}
    </section>
  );
}
